import BillingBanner from '@/components/BillingBanner';
import BillingNotifications from '@/components/billing/BillingNotifications';
import DevelopmentBanner from '@/components/dev/DevelopmentBanner';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Footer from '../footer/Footer';

// Import the new components
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import DashboardHeader from '../dashboard/DashboardHeader';
import DashboardSidebar from '../dashboard/Sidebar';
interface DashboardLayoutProps {
  children?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { user, isLoading, isCheckingTenantStatus, isSigningIn, isSystemAdmin } = useAuth();

  // Removed error suppression - let all errors surface for proper debugging

  // Show loading indicator while checking auth status, signing in, or checking tenant status
  if (isLoading || isSigningIn || isCheckingTenantStatus) {
    console.log('DashboardLayout: Showing loading screen', {
      isLoading,
      isSigningIn,
      isCheckingTenantStatus,
    });
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  // If not authenticated, redirect to login
  if (!user) {
    return <Navigate to="/login" />;
  }

  // If system admin, redirect to system admin dashboard
  if (isSystemAdmin) {
    return <Navigate to="/system-admin" replace />;
  }


  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex h-screen w-full overflow-hidden">
        {/* Dashboard Sidebar */}
        <DashboardSidebar />

        {/* Main Content Area */}
        <SidebarInset className="flex-1">
          <div className="flex flex-col min-h-full">
            <DevelopmentBanner />
            {/* Dashboard Header */}
            <DashboardHeader />

            {/* Main Content */}
            <main className="flex-1 overflow-y-scroll">
              <div className="container mx-auto p-6">
                <BillingBanner />
                <BillingNotifications />
                {/* If locked, we still render, but downstream pages should gate actions */}
                {children || <Outlet />}
              </div>
            </main>

            {/* Footer */}
            <Footer />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default DashboardLayout;
